import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';

import { Actions, createEffect, ofType } from '@ngrx/effects';

import { ProfileActions } from './profile.actions';
import { environment } from "../../../../environments/environment";
import { VariablesService } from '../../../partials/services/variables.service';
import { TokenRefreshService } from "../../../api/services/token-refresh.service";
import { TwoFactorService } from "../../../api/services/two-factor.service";
import { takePostLoginRedirectUrl } from "../../../partials/helpers/post-login-redirect";

@Injectable()
export class ProfileStoreEffects {
    private apiUrl: string;

    constructor(
        private _actions$: Actions,
        private _http: HttpClient,
        private _router: Router,
        private _variablesService: VariablesService,
        private _tokenRefreshService: TokenRefreshService,
        private _twoFactorService: TwoFactorService,
    ) {
        this.apiUrl = environment.apiUrl;
    }

    logout$ = createEffect(() => this._actions$.pipe(
        ofType(ProfileActions.logout),
        tap(() => {
            this._tokenRefreshService.stop();
            localStorage.removeItem('token');
            localStorage.removeItem('tokenExpiresAt');
            localStorage.removeItem('userInfo');
            localStorage.removeItem('corporateFilter');
            localStorage.removeItem('merchantFilter');
            this._router.navigate(['/login']);
        })
    ), { dispatch: false });

    loginSuccess$ = createEffect(() => this._actions$.pipe(
        ofType(ProfileActions.loginSuccess),
        tap((action) => {
            localStorage.removeItem('authStep');
            localStorage.setItem('userInfo', JSON.stringify(action.payload));
            localStorage.setItem('token', action.payload.token);

            const expiresAt = Date.now() + (action.payload.sessionExpiresIn ?? 1800) * 1000;
            localStorage.setItem('tokenExpiresAt', String(expiresAt));

            this._variablesService.role.set(action.payload.role);
            // this._variablesService.role.set('MANAGER');
            this._tokenRefreshService.start();
            // Cache the 2FA enrollment flag right after login so critical actions can prompt up-front
            // (app-config-init only runs on a full reload, not after an in-SPA login).
            this._twoFactorService.loadStatus().subscribe({ error: () => {} });

            const redirectUrl = takePostLoginRedirectUrl();

            if (redirectUrl) {
                this._router.navigateByUrl(redirectUrl);
                return;
            }

            this._router.navigate(['/merchants']);
        }),
        map((action) => ProfileActions.loadSuccess({ profile: action.payload }))
    ));

    loginProcess$ = createEffect(() => this._actions$.pipe(
        ofType(ProfileActions.loginProcess),
        mergeMap((action) => {
            return this._http.post(`${ this.apiUrl }api/login/process`, action.payload).pipe(
                map((response: any) => ProfileActions.loginProcessSuccess({ payload: response })),
                catchError(error => of(ProfileActions.loginProcessFail({ error }))),
            );
        })
    ));

    login$ = createEffect(() => this._actions$.pipe(
        ofType(ProfileActions.login),
        mergeMap((action) => {
            return this._http.post(`${ this.apiUrl }api/admin/login`, { key: action.key }).pipe(
                map((response: any) => ProfileActions.loginSuccess({ payload: response })),
                catchError(error => of(ProfileActions.loginFail({ error }))),
            );
        })
    ));
}
